export interface Product {
  id: string;
  priceId: string;
  name: string;
  description: string;
  mode: 'payment' | 'subscription';
  price: number;
  currency: string;
  interval?: 'month' | 'year';
}

export const products: Product[] = [
  {
    id: 'prod_SfVfsw7Nujj4gC',
    priceId: 'price_1RkAdnGgeEGrzrONsu86JLRr',
    name: 'CDMO Premium Access',
    description: 'Get premium access to our CDMO network with advanced matching features, priority introductions, and exclusive partner insights.',
    mode: 'subscription',
    price: 1200.00,
    currency: 'usd',
    interval: 'month'
  }
];

export const getProductById = (id: string): Product | undefined => {
  return products.find(product => product.id === id);
};

export const getProductByPriceId = (priceId: string): Product | undefined => {
  return products.find(product => product.priceId === priceId);
};